import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export function WinnerBadge() {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="text-[#FFD700] font-bold text-sm md:text-base ml-1.5 cursor-help">
            SLEEZE
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <p>This guy FUCKS</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

